var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.21 257.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-3 {\n        fill: #e8d8bb;\n      }\n\n      .cls-4 {\n        fill: #d5d1c1;\n      }\n\n      .cls-5 {\n        fill: #37474f;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-8 {\n        fill: #455a64;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        fill: #a6a6a6;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-16 {\n        fill: #e7d7ba;\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-19 {\n        fill: #ebebeb;\n      }\n\n      .cls-20 {\n        opacity: .1;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-31 {\n        fill: #263238;\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 55.38,
    y1: 157.02,
    x2: 424.16,
    y2: 157.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef7e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.31,
    y1: 74.29,
    x2: 470.99,
    y2: 74.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c927f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 250.32,
    y2: 250.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.31,
    y1: 236.57,
    x2: 458.99,
    y2: 236.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7d7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8ad97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 42.6,
    y1: 93.45,
    x2: 90.41,
    y2: 93.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 33.73,
    y1: 223.18,
    x2: 99.29,
    y2: 223.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 44.06,
    y1: 210.16,
    x2: 88.95,
    y2: 210.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 44.67,
    y1: 151.8,
    x2: 88.34,
    y2: 151.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 136.24,
    y1: 93.45,
    x2: 184.06,
    y2: 93.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 127.37,
    y1: 223.18,
    x2: 192.93,
    y2: 223.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 137.71,
    x2: 182.6,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 138.32,
    y1: 151.8,
    x2: 181.99,
    y2: 151.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 297.62,
    y1: 93.45,
    x2: 345.44,
    y2: 93.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 288.75,
    y1: 223.18,
    x2: 354.31,
    y2: 223.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 299.08,
    x2: 343.97,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 299.69,
    y1: 151.8,
    x2: 343.36,
    y2: 151.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 389.13,
    y1: 93.45,
    x2: 436.95,
    y2: 93.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 380.26,
    y1: 223.18,
    x2: 445.82,
    y2: 223.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 390.6,
    x2: 435.49,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 391.21,
    y1: 151.8,
    x2: 434.88,
    y2: 151.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -4293.11,
    y1: 2756.67,
    x2: -4293.11,
    y2: 2756.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -4293.11,
    y1: 2756.67,
    x2: -4293.11,
    y2: 2756.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -4293.11,
    y1: 2756.67,
    x2: -4293.11,
    y2: 2756.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -4293.11,
    y1: 2756.67,
    x2: -4293.11,
    y2: 2756.67,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.6,253.07s-2.12-9.81-6.34-11.4c-4.22-1.58-6.8,2.92-6.8,2.92,0,0-1-9.44-7.01-12.25-6.02-2.82-10.49,2.96-10.49,2.96,0,0-4.6-11.97-12.82-11.97s-12.35,17.51-12.35,17.51c0,0-4.85-5.22-9.81-2.27C.01,241.5,0,253.07,0,253.07h70.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m486.21,252.25h-32.99s.07-4.91,3.31-6.21c1.81-.79,3.92-.28,5.17,1.24,0,0,1.32-9.04,7.37-9.04s8.94,7.79,8.94,7.79c1.05-1.53,2.91-2.28,4.73-1.92,3.32.44,3.47,8.13,3.47,8.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 55.38,
    y: 72.06,
    width: 368.78,
    height: 169.92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 72.87,
    y: 148.08,
    width: 81.79,
    height: 59.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 75.19,
    y: 150.4,
    width: 77.14,
    height: 54.92
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.33 189.78 152.33 200.96 147.97 205.32 136.78 205.32 152.33 189.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "122.66 150.4 75.19 197.87 75.19 186.68 111.48 150.4 122.66 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.63 150.4 75.19 204.84 75.19 202.47 127.27 150.4 129.63 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.33 171.79 152.33 174.14 121.15 205.32 118.79 205.32 152.33 171.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.33 205.22 152.33 205.32 152.23 205.32 152.33 205.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "101.78 150.4 75.19 176.99 75.19 172.36 97.15 150.4 101.78 150.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 321.53,
    y: 148.08,
    width: 81.79,
    height: 59.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 323.85,
    y: 150.4,
    width: 77.14,
    height: 54.92
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "400.99 189.78 400.99 200.96 396.63 205.32 385.44 205.32 400.99 189.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "371.32 150.4 323.85 197.87 323.85 186.68 360.14 150.4 371.32 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "378.29 150.4 323.85 204.84 323.85 202.47 375.93 150.4 378.29 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "400.99 171.79 400.99 174.14 369.81 205.32 367.45 205.32 400.99 171.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "400.99 205.22 400.99 205.32 400.89 205.32 400.99 205.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "350.44 150.4 323.85 176.99 323.85 172.36 345.81 150.4 350.44 150.4"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.31,
    y: 70.37,
    width: 460.68,
    height: 7.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 10.31,
    y: 243.44,
    width: 460.68,
    height: 13.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 22.31,
    y: 229.69,
    width: 436.68,
    height: 13.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "26.33 70.83 240.65 0 454.97 70.83 26.33 70.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "102.87 58.59 240.65 13.06 378.44 58.59 102.87 58.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208,
    y: 150.84,
    width: 33.62,
    height: 78.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 213,
    y: 155.96,
    width: 23.62,
    height: 53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.62 155.96 236.62 160.62 213 184.24 213 173.05 230.08 155.96 236.62 155.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.62 180.37 236.62 191.55 219.25 208.96 213 208.96 213 204.02 236.62 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.62 175.46 236.62 177.82 213 201.48 213 199.11 236.62 175.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "227.71 155.96 213 170.67 213 166.04 223.08 155.96 227.71 155.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 238.12,
    y: 191.62,
    width: 1.63,
    height: 8.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 213,
    y: 194.16,
    width: 23.62,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.92,
    y: 150.84,
    width: 33.62,
    height: 78.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 246.92,
    y: 155.96,
    width: 23.62,
    height: 53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.54 155.96 270.54 160.62 246.92 184.24 246.92 173.05 264 155.96 270.54 155.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.54 180.37 270.54 191.55 253.17 208.96 246.92 208.96 246.92 204.02 270.54 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.54 175.46 270.54 177.82 246.92 201.48 246.92 199.11 270.54 175.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "261.63 155.96 246.92 170.67 246.92 166.04 257 155.96 261.63 155.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 243.79,
    y: 191.62,
    width: 1.63,
    height: 8.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 246.92,
    y: 194.16,
    width: 23.62,
    height: 3.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.42,
    y: 108.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.96,
    y: 114.05,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 251,
    y: 130.11,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 256.54,
    y: 135.4,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 370.55,
    y: 213.93,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 376.09,
    y: 219.22,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 355.73,
    y: 108.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 350.19,
    y: 114.05,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 177.82,
    y: 122.82,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 172.28,
    y: 128.11,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 101.7,
    y: 132.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.93,
    y: 211.83,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 235.87,
    y: 104,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 283.78,
    y: 114.05,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 388.25,
    y: 132.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 42.6,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 33.73,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "88.95 216.67 44.06 216.67 44.67 203.65 88.34 203.65 88.95 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "88.34 203.65 44.67 203.65 49.57 99.95 83.44 99.95 88.34 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 136.24,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 127.37,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.6 216.67 137.71 216.67 138.32 203.65 181.99 203.65 182.6 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "181.99 203.65 138.32 203.65 143.22 99.95 177.09 99.95 181.99 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 297.62,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 288.75,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "343.97 216.67 299.08 216.67 299.69 203.65 343.36 203.65 343.97 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "343.36 203.65 299.69 203.65 304.59 99.95 338.46 99.95 343.36 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 389.13,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 380.26,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "435.49 216.67 390.6 216.67 391.21 203.65 434.88 203.65 435.49 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "434.88 203.65 391.21 203.65 396.11 99.95 429.98 99.95 434.88 203.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m213.31,48.29c0,3.81-3.14,5.62-7.87,5.62h-11.31v-21.15h10.95c4.71,0,7.67,1.69,7.67,5.62,0,2.66-1.16,4.52-3.23,4.95,2.14.2,3.79,2.16,3.79,4.95Zm-8.52-6.95c1.25,0,2.17-.94,2.17-2.37s-.92-2.37-2.37-2.37h-4.5v4.74h4.7Zm.15,8.61c1.48,0,2.36-.89,2.36-2.37s-.97-2.37-2.34-2.37h-4.86v4.74h4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m229.89,53.91l-1.16-3.87h-7.4l-1.16,3.87h-6.16l7.02-21.15h7.94l7.05,21.15h-6.13Zm-2.42-8.05l-2.45-8.14-2.45,8.14h4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m258.01,32.76v21.15h-6.37l-7.58-11.8v11.8h-5.97v-21.15h6.37l7.58,11.81v-11.81h5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m267.53,41.81l6.57-9.05h6.9l-7.96,10.57,8.07,10.57h-7.01l-6.57-9.05v9.05h-5.97v-21.15h5.97v9.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m212.31,47.29c0,3.81-3.14,5.62-7.87,5.62h-11.31v-21.15h10.95c4.71,0,7.67,1.69,7.67,5.62,0,2.66-1.16,4.52-3.23,4.95,2.14.2,3.79,2.16,3.79,4.95Zm-8.52-6.95c1.25,0,2.17-.94,2.17-2.37s-.92-2.37-2.37-2.37h-4.5v4.74h4.7Zm.15,8.61c1.48,0,2.36-.89,2.36-2.37s-.97-2.37-2.34-2.37h-4.86v4.74h4.85Zm24.95,3.96l-1.16-3.87h-7.4l-1.16,3.87h-6.16l7.02-21.15h7.94l7.05,21.15h-6.13Zm-2.42-8.05l-2.45-8.14-2.45,8.14h4.89Zm30.53-13.1v21.15h-6.37l-7.58-11.8v11.8h-5.97v-21.15h6.37l7.58,11.81v-11.81h5.97Zm9.52,9.05l6.57-9.05h6.9l-7.96,10.57,8.07,10.57h-7.01l-6.57-9.05v9.05h-5.97v-21.15h5.97v9.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.31,
    y: 78.33,
    width: 436.68,
    height: 9.35
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c142b1091da1433993eb3d3c8d8eb00d.svg";
export { ForwardRef as ReactComponent };